import { render, staticRenderFns } from "./otherCourses.vue?vue&type=template&id=3cd0f66c&scoped=true&"
import script from "./otherCourses.vue?vue&type=script&lang=js&"
export * from "./otherCourses.vue?vue&type=script&lang=js&"
import style0 from "./otherCourses.vue?vue&type=style&index=0&id=3cd0f66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0f66c",
  null
  
)

export default component.exports